import(/* webpackMode: "eager" */ "/vercel/path0/apps/storefront/app/global-error.tsx");
